<template>
  <v-container>
    <v-row :class="$vuetify.breakpoint.smAndDown || 'pa-12'">
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
        <p style="font-size: 14px">
          En este apartado podrás crear subgrupos con los que podrás segmentar
          comunicados, eventos y beneficios
        </p>
      </v-col>
      <v-col
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 6"
        class="d-flex justify-end"
      >
        <v-btn
          @click="openManageMembersDialog"
          color="primary"
          class="rounded-pill font-weight-bold"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon> Agregar Subgrupo
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="subgroups" item-key="name">
          <template v-slot:[`item.members`]="{ item }">
            <span class="mr-2 ml-3">{{
              getSubgroupsItemsLength(item.members)
            }}</span>
            <v-btn
              icon
              small
              :disabled="item.members.length <= 0"
              @click="
                openManageMembersDialog({
                  name: item.name,
                  members: item.members,
                  handleMode: 'WATCH',
                })
              "
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="text-end">
              <v-icon
                small
                @click="
                  openManageMembersDialog({
                    _id: item._id,
                    members: item.members,
                    name: item.name,
                    handleMode: 'EDIT',
                  })
                "
                class="ml-1 mr-5"
                >mdi-pencil</v-icon
              >
              <v-icon small @click="openDeleteDialog(item)">mdi-delete</v-icon>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card class="pa-4">
        <v-card-title class="d-flex justify-center">
          <span class="headline font-weight-bold">Confirmar eliminación</span>
        </v-card-title>
        <v-card-text>
          ¿Estás seguro de que quieres eliminar el subgrupo
          <b>"{{ subgroupToDelete ? subgroupToDelete.name : '' }}"</b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDeleteDialog"
            class="rounded-pill font-weight-bold"
            elevation="0"
            >Cancelar</v-btn
          >
          <v-btn
            color="red"
            class="rounded-pill font-weight-bold white--text"
            elevation="0"
            @click="confirmDeleteSubgroup"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <personalized-dialog
      hideImage
      hideName
      :dialog="!!subgroupHandler"
      :dimentions="{ width: 700 }"
      @save="manageMembersSaveAction(subgroupHandler)"
      @discard="subgroupHandler = null"
    >
      <template #alertContent>
        <manage-members :subgroupData="subgroupHandler" />
      </template>
    </personalized-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import ManageMembers from './components/ManageMembers.vue';
import { mapActions } from 'vuex';
import { mapMutations } from 'vuex';
import PersonalizedDialog from '../../../components/shared/PersonalizedDialog.vue';

export default {
  components: {
    PersonalizedDialog,
    ManageMembers,
  },
  data() {
    return {
      deleteDialog: false,
      subgroupToDelete: null,
      searchName: '',
      id: '',
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Miembros', value: 'members', align: 'end' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
      ],
      testo: [],
      subgroups: [],
      users: [],
      tinton: [],
      selectedUsers: [],
      selectedMembers: [],
      dialog: false,
      dialogType: '',
      editedSubgroup: {},
      formValid: false,
      rules: {
        required: (value) => !!value || 'Este campo es requerido',
      },
      loadingUsers: false,
      eventsSearchData: {
        name: '',
        page: 1,
        perPage: 10,
        validationStatus: '',
        role: '',
      },
      typingTimer: null,
      preservedSearchName: '',
      subgroupHandler: null,
    };
  },
  async created() {
    await this.fetchSubgroups();
  },
  watch: {},
  computed: {
    // Computed property para verificar si el formulario es válido
    isFormValid() {
      return this.editedSubgroup.name && this.selectedUsers.length > 0;
    },
  },

  methods: {
    ...mapMutations('notification', ['show']),
    ...mapMutations('loader', ['loading', 'loaded']),
    ...mapActions('user', ['realoadUserData']),
    ...mapActions('members', ['getBranchMembersPaginated']),

    formatMembers(members) {
      return members.map((member) => member.name).join(', ');
    },
    handleEnterKey() {
      this.$nextTick(() => {
        if (this.$refs.autocompleteMenu) {
          this.preservedSearchName = this.searchName;

          this.$refs.autocompleteMenu.isMenuActive = false;

          setTimeout(() => {
            this.$refs.autocompleteMenu.isMenuActive = true;
            this.searchName = this.preservedSearchName;
          }, 100);
        }
      });
    },

    async updateUserSubgroups(subgroupName, userIds) {
      try {
        for (const userId of userIds) {
          const putUser = {
            subgroup: subgroupName,
          };

          const response = await this.axios({
            method: 'put',
            url: '/members/form/' + userId,
            data: putUser,
          });

          if (response.status !== 200) {
            console.error(`Error actualizando el subgrupo`);
          }
        }
        this.show({
          text: 'Subgrupo actualizado exitosamente!',
          color: 'success',
          time: 2000,
        });
      } catch (error) {
        console.error('Error actualizando subgrupo:', error);
        this.show({
          text: '¡Error al actualizar subgrupo!',
          color: 'error',
        });
      }
    },

    async fetchSubgroups() {
      this.loading();
      try {
        const response = await axios.get('/subgroups');
        this.subgroups = response.data;
      } catch (error) {
        console.error('Error fetching subgroups:', error);
      }
      this.loaded();
    },

    openManageMembersDialog({
      members = [],
      name = '',
      handleMode = 'CREATE',
      _id = null,
    }) {
      this.subgroupHandler = { members, name, handleMode, _id };
    },

    async manageMembersSaveAction(handler) {
      if (handler.handleMode === 'WATCH') return;

      if (handler.handleMode === 'CREATE') {
        await this.createSubgroup(handler);
      } else if (handler.handleMode === 'EDIT') {
        await this.updateSubgroup(handler);
      }
      await this.fetchSubgroups();
    },

    async createSubgroup(payload) {
      try {
        await axios.post('/subgroups', {
          name: payload.name,
          members: [...payload.members].map((e) => e._id),
        });
        this.show({
          text: 'Subgrupo creado exitosamente!',
          color: 'success',
          time: 2000,
        });
      } catch (error) {
        console.error('Error creating subgroup:', error);
        this.show({
          text: 'Ocurrió un error al crear el subgrupo.',
          color: 'error',
        });
      }
    },

    async updateSubgroup(payload) {
      try {
        console.log(payload);
        await axios.put(`/subgroups/${payload._id}`, {
          name: payload.name,
          members: [...payload.members].map((e) => e._id),
        });
        this.show({
          text: 'Subgrupo actualizado exitosamente!',
          color: 'success',
          time: 2000,
        });
      } catch (error) {
        console.error('Error updating subgroup:', error);
        this.show({
          text: 'Ocurrió un error al actualizar el subgrupo.',
          color: 'error',
        });
      }
    },

    async deleteSubgroup(subgroup) {
      try {
        await axios.delete(`/subgroups/${subgroup._id}`);
        await this.fetchSubgroups();
      } catch (error) {
        console.error('Error deleting subgroup:', error);
      }
    },

    openDeleteDialog(subgroup) {
      this.subgroupToDelete = subgroup;
      this.deleteDialog = true;
    },

    // Cierra el diálogo de eliminación
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.subgroupToDelete = null;
    },

    // Confirma la eliminación del subgrupo
    async confirmDeleteSubgroup() {
      if (this.subgroupToDelete) {
        try {
          await axios.delete(`/subgroups/${this.subgroupToDelete._id}`);
          await this.fetchSubgroups(); // Recarga los subgrupos
          this.show({
            text: 'Subgrupo eliminado exitosamente!',
            color: 'success',
            time: 2000,
          });
        } catch (error) {
          console.error('Error deleting subgroup:', error);
          this.show({
            text: 'Ocurrió un error al eliminar el subgrupo.',
            color: 'error',
          });
        }
      }
      this.closeDeleteDialog();
    },

    getSubgroupsItemsLength(members = []) {
      return members.length;
    },
  },
  watch: {},
};
</script>
